export default __webpack_public_path__ + "cfcfb86c828aa31838cfca235a6768b9.png";